"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PriceSlash = require("./PriceSlash.style");

var PriceSlash = function PriceSlash(_ref) {
  var price = _ref.price,
      cards = _ref.cards;
  return /*#__PURE__*/_react.default.createElement(_PriceSlash.PriceWrap, null, price.previous && /*#__PURE__*/_react.default.createElement(_PriceSlash.PricePrevious, {
    size: cards.previousPriceSize
  }, price.previous), price.current && /*#__PURE__*/_react.default.createElement(_PriceSlash.PriceCurrent, {
    size: cards.currentPriceSize,
    price: price
  }, price.current));
};

PriceSlash.propTypes = {
  cards: _propTypes.default.shape({
    previousPriceSize: _propTypes.default.string,
    currentPriceSize: _propTypes.default.string
  }),
  price: _propTypes.default.shape({
    previous: _propTypes.default.string,
    current: _propTypes.default.string
  })
};
PriceSlash.defaultProps = {
  cards: {
    copyTextSize: 'medium',
    currentPriceSize: 'xlarge'
  },
  price: {
    previous: '',
    current: ''
  }
};
var _default = PriceSlash;
exports.default = _default;